import { Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onViewExisting: () => void;
    onClose: () => void;
};

const EnsAlreadyExistsModal = ({ open, onConfirm, onViewExisting, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={600}
            open={open}
            title="ENS Already Exists"
            icon={<CopyOutlined />}
            confirmButtonText="Continue"
            cancelButtonText="View Existing ENS"
            onConfirm={onConfirm}
            onCancel={onViewExisting}
            onClose={onClose}
            content={
                <Typography.Text>
                    An ENS declaration already exists for this manifest. Proceeding will create a duplicate. Are you
                    sure you want to continue?
                </Typography.Text>
            }
        />
    );
};

export default EnsAlreadyExistsModal;
